export default __webpack_public_path__ + "static/media/logo-cyd.9a2510e2.png";